import React from 'react';
import { Mix } from '@ant-design/plots';
import {result} from "@store/resultData";




const SystemsColumnResult = () => {
    const data = result;
    /*const [data, setData] = useState({});

    useEffect(() => {
        asyncFetch();
    }, []);

    const asyncFetch = () => {
        fetch('https://gw.alipayobjects.com/os/antfincdn/fKTgtjKdaN/association-pie.json')
            .then((response) => response.json())
            .then((json) => setData(json))
            .catch((error) => {
                console.log('fetch data failed', error);
            });
    };
    if (!Object.keys(data).length) {
        return null;
    }*/

    console.log(data);

    const config = {
        // 关闭 chart 上的 tooltip，子 view 开启 tooltip
        tooltip: false,
        legend: true,
        plots: [
            {
                type: 'pie',
                region: {
                    start: {
                        x: 0,
                        y: 0,
                    },
                    end: {
                        x: 0.45,
                        y: 1,
                    },
                },
                options: {
                    data: data.pie1,
                    angleField: 'bill',
                    colorField: 'area',
                    color: ['#f5222d', '#1890ff'],
                    radius: 0.5,
                    tooltip: {
                        showMarkers: false,
                    },
                    label: {
                        type: 'outer',
                        content: '{name} {percentage}'
                    },
                    interactions: [
                        {
                            type: 'element-active',
                        },
                        {
                            type: 'association-tooltip',
                        },
                        {
                            type: 'association-highlight',
                        },
                    ],
                },
            },
            {
                type: 'pie',
                region: {
                    start: {
                        x: 0.55,
                        y: 0,
                    },
                    end: {
                        x: 1,
                        y: 1,
                    },
                },
                options: {
                    data: data.pie2,
                    radius: 0.5,
                    angleField: 'value',
                    colorField: 'area',
                    color: ['#f5222d', '#1890ff'],
                    label: {
                        type: 'outer',
                        content: '{name} {percentage}'
                    },
                    tooltip: {
                        showMarkers: false,
                    },
                    interactions: [
                        {
                            type: 'association-tooltip',
                        },
                        {
                            type: 'association-selected',
                        },
                    ],
                },
            },
        ],
    };

    return <Mix {...config} />;
};

export default SystemsColumnResult;
